import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useDebounce } from 'react-use';

/**
 * Custom hook to debounce logging form validation errors.
 * It waits for a specified delay after the last keystroke before logging the errors to the console.
 * This reduces the number of log messages and only shows the final validation errors.
 *
 * @param delay The debounce delay in milliseconds. Default is 500ms.
 */
export function useDebouncedFormikErrorsLog(delay = 500) {
  const formikProps = useFormikContext();

  // Use the useDebounce hook to debounce the form validation error logging
  const [, cancel] = useDebounce(
    () => {
      if (!formikProps.isValid) {
        console.log('Form validation errors: ', formikProps.errors);
      }
    },
    delay,
    [formikProps.isValid, formikProps.errors]
  );

  useEffect(() => {
    return () => {
      cancel(); // Cleanup
    };
  }, [cancel]);
}
